/**
 * ClassifierDetails.shortDescription is a plain `String` in the Prisma schema,
 * which maps to VARCHAR(191) in MySQL — anything longer is silently truncated
 * at the database (observed in practice; the init migration's 255 no longer
 * reflects the live column). The create/edit forms enforce the same ceiling
 * before submitting rather than letting users type text that won't survive
 * the save.
 */
export const SHORT_DESCRIPTION_MAX_LENGTH = 191

/**
 * The name columns (displayName, clientFacingName) are also VARCHAR(191),
 * but a name anywhere near that long overflows the tables, mastheads and
 * pickers that render it. 100 is a deliberate UI ceiling, not the database
 * limit.
 */
export const NAME_MAX_LENGTH = 100
